import { Sparkle } from "lucide-react";

const ITEMS = [
    "Tecnologia",
    "Intelligenza Artificiale Performance",
    "Creator Economy",
    "Innovazione Digitale",
    "Consulenza Aziendale",
    "Formazione Creator",
];

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative overflow-hidden bg-[#03045E] py-5 border-y border-[#0077B6]/40"
        aria-hidden="true"
    >
        <div className="animate-marquee flex w-max items-center gap-10 pr-10">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span
                    key={i}
                    className="flex items-center gap-10 font-display text-lg sm:text-xl font-semibold tracking-wide text-[#90E0EF] whitespace-nowrap"
                >
                    {item}
                    <Sparkle className="h-4 w-4 text-[#48CAE4]" />
                </span>
            ))}
        </div>
    </div>
);
